import { render, staticRenderFns } from "./MemberDetailPortfolioLayout.vue?vue&type=template&id=2a674fbf&scoped=true"
import script from "./MemberDetailPortfolioLayout.vue?vue&type=script&lang=js"
export * from "./MemberDetailPortfolioLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a674fbf",
  null
  
)

export default component.exports